import { z } from 'zod';

/** A change file's types, in the order a release lists them (QZ-D190). */
export const CHANGELOG_TYPES = ['added', 'changed', 'fixed', 'removed'] as const;
export const changelogTypeSchema = z.enum(CHANGELOG_TYPES);
export type ChangelogType = z.infer<typeof changelogTypeSchema>;

/** One line of a release: its type and one or two sentences of inline Markdown (QZ-D190). */
export const changelogEntrySchema = z
  .object({ type: changelogTypeSchema, text: z.string().min(1) })
  .strip();
export type ChangelogEntry = z.infer<typeof changelogEntrySchema>;

/** A release, named by the date `next` was merged to `main` (QZ-D190). */
export const changelogReleaseSchema = z
  .object({
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    entries: z.array(changelogEntrySchema),
  })
  .strip();
export type ChangelogRelease = z.infer<typeof changelogReleaseSchema>;

/** `changelog.json`, the changelog of record: releases newest first (QZ-D190). */
export const changelogSchema = z.object({ releases: z.array(changelogReleaseSchema) }).strip();
export type Changelog = z.infer<typeof changelogSchema>;
